// import React, { Component } from "react";
// import Accounting from "../../../Assets/img/jobAcc.svg";
// import Medic from "../../../Assets/img/jobMedic.svg";
// import Eng from "../../../Assets/img/jobEng.svg";
// import art from "../../../Assets/img/jobArt.svg";
// import law from "../../../Assets/img/jobLaw.svg";
// import megaphone from "../../../Assets/img/megaphone.png";
// import manager from "../../../Assets/img/jobEng.svg";
// import discussion from "../../../Assets/img/discussion.png";
// import presentation from "../../../Assets/img/presentation.png";
// import Header from "../../Hoc/Header";
// import Footer from "../../Hoc/Footer";
// import { Link } from "react-router-dom";
// import styles from "./Job.module.scss";
// import { FiCheckSquare } from "react-icons/fi";

// export default class Job extends Component {
//   render() {
//     return (
//       <>
//         <div className={styles.job}>
//           <Header title="دسته بندی شغلی" />

//           <div className={styles.jobBody}>
//             <Link to={`/job-list/medical`}>
//               <div className={styles.jobCard}>
//                 <img src={Medic} alt="medical" />

//                 <div className={styles.jobCardText}>
//                   <h4>پزشکی</h4>
//                 </div>
//               </div>
//             </Link>

//             <Link to={`/job-list/accounting`}>
//               <div className={styles.jobCard}>
//                 <img src={Accounting} alt="Accounting" />

//                 <div className={styles.jobCardText}>
//                   <h4>حسابداری</h4>
//                 </div>
//               </div>
//             </Link>

//             <Link to={`/job-list/engineering`}>
//               <div className={styles.jobCard}>
//                 <img src={Eng} alt="Eng" />

//                 <div className={styles.jobCardText}>
//                   <h4>مهندسی</h4>
//                 </div>
//               </div>
//             </Link>

//             <Link to={`/job-list/art`}>
//               <div className={styles.jobCard}>
//                 <img src={art} alt="Eng" />

//                 <div className={styles.jobCardText}>
//                   <h4>هنر</h4>
//                 </div>
//               </div>
//             </Link>

//             <Link to={`/job-list/law`}>
//               <div className={styles.jobCard}>
//                 <img src={law} alt="Eng" />

//                 <div className={styles.jobCardText}>
//                   <h4>حقوق</h4>
//                 </div>
//               </div>
//             </Link>

//             <Link to={`/job-list/management`}>
//               <div className={styles.jobCard}>
//                 <img src={law} alt="Eng" />

//                 <div className={styles.jobCardText}>
//                   <h4>مدیریت</h4>
//                 </div>
//               </div>
//             </Link>

//             <Link to={`/job-list/teacher`}>
//               <div className={styles.jobCard}>
//                 <img src={law} alt="Eng" />

//                 <div className={styles.jobCardText}>
//                   <h4>معلم</h4>
//                 </div>
//               </div>
//             </Link>

//             <Link to={`/job-list/consultant`}>
//               <div className={styles.jobCard}>
//                 <img src={law} alt="Eng" />

//                 <div className={styles.jobCardText}>
//                   <h4>مشاور</h4>
//                 </div>
//               </div>
//             </Link>

//             <Link className="law-style" to={`/job-list/marketing`}>
//               <div className={styles.jobCard}>
//                 <img src={law} alt="Eng" />

//                 <div className={styles.jobCardText}>
//                   <h4>بازار یابی و فروش</h4>
//                 </div>
//               </div>
//             </Link>
//           </div>
//           <Footer active="job" />
//         </div>
//       </>
//     );
//   }
// }


import React, { useState, useEffect } from "react";
import Header from "../../Hoc/Header";
import Footer from "../../Hoc/Footer";
import { Link } from "react-router-dom";
import styles from "./Job.module.scss";
import axios from "axios";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

// آیکون‌های موجود (به ترتیب چرخش می‌کنن)
import Accounting from "../../../Assets/img/jobAcc.svg";
import Medic from "../../../Assets/img/jobMedic.svg";
import Eng from "../../../Assets/img/jobEng.svg";
import art from "../../../Assets/img/jobArt.svg";
import law from "../../../Assets/img/jobLaw.svg";

const icons = [Medic, Accounting, Eng, art, law];

function Job() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(
        "https://arianaapp.arianaapply.com/api/V1/show-category-job-opportunity-with-jobs"
      )
      .then((res) => {
        console.log("categories", res.data);
        // ساختار: { success, message, count, data: [...] }
        setCategories(res.data?.data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  return (
    <div className={styles.job}>
      <Header title="دسته بندی شغلی" />

      <div className={styles.jobBody}>
        {loading ? (
          <div className="spinner">
            <Loader
              type="TailSpin"
              color="rgb(236, 177, 28)"
              height={80}
              width={80}
            />
          </div>
        ) : categories.length > 0 ? (
          categories.map((item, index) => (
            <Link
              to={`/job-list/${item.category}`}
              state={{ category_fa: item.category_fa }}
              key={item._id}
            >
              <div className={styles.jobCard}>
                <img
                  src={icons[index % icons.length]}
                  alt={item.category_fa}
                />
                <div className={styles.jobCardText}>
                  <h4>{item.category_fa}</h4>
                </div>
              </div>
            </Link>
          ))
        ) : (
          <p style={{ textAlign: "center", padding: "20px" }}>
            دسته‌بندی‌ای یافت نشد
          </p>
        )}
      </div>

      <Footer active="job" />
    </div>
  );
}

export default Job;